// GxCompactSuccess.tsx
import GxButton from "@/app/components/common/actions/buttons/GxButton";
import { DATA_GIF_PATH, ICON_BASE_PATH } from "@/app/utils/config";

type GxCompactSuccessProps = {
  open: boolean;
  close: () => void;
  type: "true" | "";
  primaryText: string;
  secondaryText?: string;
  isError?: boolean;
  buttonLabel?: string;
  onButtonClick?: () => void;
};

const GxCompactSuccess = ({
  open,
  close,
  primaryText,
  secondaryText,
  type,
  isError = false,
  buttonLabel = "Ok",
  onButtonClick,
}: GxCompactSuccessProps) => {
  if (!open) return null;

  return (
    <div className="gx-technicalmodal-overlay">
      <div className="gx-technicalmodal-container">
        <button
          className="gx-dialog-close-button gx-technicalmodal-close"
          onClick={close}
        >
          <img
            className="gx-icon-primary"
            src={`${ICON_BASE_PATH}close.svg`}
            alt="Close"
          />
        </button>

        <div className="grid grid-cols-12 gap-2">
          <div className="col-span-12">
            <div className="gx-consents-technicalsuccess">
              <img
                src={`${DATA_GIF_PATH}${
                  isError ? "reject_animation" : "success"
                }.gif`}
                alt={isError ? "Error" : "Success"}
              />
            </div>
          </div>

          <div className="col-span-12 mb-2.5">
            <div className="gx-dialog-title-h2">
              <h2 className="gx-h2-26-l leading-8 text-center">
                {primaryText}
                {secondaryText && (
                  <>
                    <br />
                    <span className="gx-h2-26-b">{secondaryText}</span>
                  </>
                )}
              </h2>
            </div>
          </div>
          {type === "true" && (
            <div className="col-span-12 mb-2.5">
              <div className="gx-connectbank-logout">
                <GxButton onClick={onButtonClick} variant="filled">
                  {buttonLabel}
                </GxButton>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GxCompactSuccess;